import React, {useContext, useEffect, useState} from "react";
import TrackVASContext from "../../../TrackVASContext";
import {PageTitle} from "../../../../_metronic/layout/core";
import {GenericTable} from "../../generic/table/GenericTable";
import {defaultList} from "../../generic/InitialStates";
import {SAOrgsAddEditDialog} from "./SAOrgsAddEditDialog";
import {ENTITY_ID_ORGANIZATIONS} from "../../generic/Constants";
import {DMSDateColumnFormatter} from "../../../column-formatters/DMSDateColumnFormatter";
import {ActionsColumnFormatter} from "../../../column-formatters/ActionsColumnFormatter";
import {HeaderColumnFormatter} from "../../../column-formatters/HeaderColumnFormatter";

export function SAOrgsPage() {
    const myData = useContext(TrackVASContext);
    const [reload, setReload] = useState(1);
    const [pageLoadComplete, setPageLoadComplete] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [showModelId, setShowModelId] = useState(null);

    const profileBreadCrumbs = [
        {
            title: "Home",
            path: "/dashboard",
            isSeparator: false,
            isActive: false,
        },
        {
            title: "",
            path: "",
            isSeparator: true,
            isActive: false,
        },
    ];

    const columns = [
        {
            dataField: "name",
            text: "Organization Name",
            formatter: HeaderColumnFormatter,
            search: true
        },
        {
            dataField: "phone",
            text: "Phone Number",
        },
        {
            dataField: "active",
            text: "Active",
        },
        {
            dataField: "createdOn",
            text: "Created On",
            formatter: DMSDateColumnFormatter,
        },
        {
            dataField: "updatedOn",
            text: "Updated On",
            formatter: DMSDateColumnFormatter,
        },
        {
            dataField: "adminUserName",
            text: "Admin User",
        },
        {
            dataField: "action",
            text: "Actions",
            formatter: ActionsColumnFormatter,
            formatExtraData: {
                buttons:
                    [
                        {
                            name: "Edit",
                            color: "primary",
                            icon: "edit",
                            method: openEditDialog
                        },
                        {
                            name: "Delete",
                            color: "danger",
                            icon: "trash-alt",
                            method: openDeleteDialog
                        }
                    ],
            },
            classes: "text-right pr-0",
            headerClasses: "text-right pr-3",
            style: {
                minWidth: "100px",
            },
        },
    ];

    function reloadData() {
        setReload(reload + 1);
    }

    function openEditDialog(row) {
        setShowModelId(row.id);
        setShowModal(true);
    }

    function openDeleteDialog(row) {
    }

    function addButtonClicked() {
        setShowModelId(null);
        setShowModal(true);
    }

    const handleClose = () => setShowModal(false);

    useEffect(() => {
        myData.setBaseData({
            toolBarButtons: [
                {
                    name: "ADD ORG",
                    color: "primary",
                    icon: "fa fa-plus",
                    onClick: addButtonClicked,
                },
            ],
        });

        setPageLoadComplete(true);

        return () => {
            myData.setBaseData({
                toolBarButtons: []
            });
        };
    }, []);

    return (
        <>
            <PageTitle breadcrumbs={profileBreadCrumbs}>Organizations</PageTitle>
            <div className="card card-body">
                {pageLoadComplete && (
                    <GenericTable
                        reload={reload}
                        defaultData={defaultList}
                        columns={columns}
                        entityId={ENTITY_ID_ORGANIZATIONS}
                    />
                )}
            </div>
            <SAOrgsAddEditDialog show={showModal} handleClose={handleClose} id={showModelId} onSave={reloadData}/>
        </>
    );
}
